import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer, useState } from "react";
import dayjs from "dayjs";
import { channelConstants } from "./dashboard.constants";
/**
 * @typedef {Object} DashboardState
 * @description Shape of the reducer state. Extend as needed.
 * @property {any} [key] - Example placeholder property
 */
/**
 * @typedef {Object} DashboardAction
 * @property {string} type - Action type
 * @property {any} [payload] - Optional action payload
 */
/**
 * @typedef {Object} DashboardContextType
 * @property {DashboardState} state - Current reducer state
 * @property {React.Dispatch<DashboardAction>} dispatch - Reducer dispatch function
 * @property {string} startDateForAPI - Start date string for API in ISO format
 * @property {function(string):void} setStartDateForAPI - Setter for startDateForAPI
 * @property {string} endDateForAPI - End date string for API in ISO format
 * @property {function(string):void} setEndDateForAPI - Setter for endDateForAPI
 * @property {string} selectedChannel - selected channel
 * @property {function(string):void} setSelectedChannel - setter for selectedChannel
 */
var DashboardContext = createContext(
/** @type {DashboardContextType | undefined} */ (undefined));
/**
 * @typedef {Object} DashboardProviderProps
 * @property {React.ReactNode} children - React child nodes
 */
/**
 * Reducer function for DashboardContext
 * @param {DashboardState} state - Current state
 * @param {DashboardAction} action - Action object
 * @returns {DashboardState} Updated state
 */
var reducer = function (state, action) {
    switch (action.type) {
        default:
            return state;
    }
};
/**
 * Dashboard Context Provider
 *
 * @param {DashboardProviderProps} props - Provider props
 * @returns {JSX.Element} Dashboard context provider wrapper
 */
export function DashboardContextProvider(_a) {
    var children = _a.children;
    var initialState = {};
    var _b = useReducer(reducer, initialState), state = _b[0], dispatch = _b[1];
    var _c = useState(dayjs(new Date()).format("YYYY-MM-DD") + "T00:00:00.000Z"), startDateForAPI = _c[0], setStartDateForAPI = _c[1];
    var _d = useState(dayjs(new Date()).format("YYYY-MM-DD") + "T23:59:59.999Z"), endDateForAPI = _d[0], setEndDateForAPI = _d[1];
    var _e = useState(channelConstants.ALL_CHANNEL
    // channelConstants.SMS
    ), selectedChannel = _e[0], setSelectedChannel = _e[1];
    var values = {
        state: state,
        dispatch: dispatch,
        startDateForAPI: startDateForAPI,
        setStartDateForAPI: setStartDateForAPI,
        endDateForAPI: endDateForAPI,
        setEndDateForAPI: setEndDateForAPI,
        selectedChannel: selectedChannel,
        setSelectedChannel: setSelectedChannel,
    };
    return (_jsx(DashboardContext.Provider, { value: values, children: children }));
}
/**
 * Hook to use Dashboard context
 *
 * @returns {DashboardContextType} Dashboard context values
 * @throws {Error} If used outside DashboardContextProvider
 */
export var useDashboardContext = function () {
    var context = useContext(DashboardContext);
    if (!context) {
        throw new Error("Dashboard context must be used within DashboardContextProvider");
    }
    return context;
};
